import React, { Component } from 'react';

import { Parse } from 'parse';

import moment from 'moment';

import DatePicker from 'material-ui/DatePicker';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import ObjectStore from '../../../services/object-store';

class SemesterAddDetail extends Component {

  constructor(props) {
    super(props);

    var semester = props.semester;
    if (semester === undefined || semester === null) {
      semester = ObjectStore.buildSemester();
    }

    this.state = {
      semester: semester,
    };
  }

  handleTitleChange = (e, newValue) => {
    const semester = this.state.semester;
    semester.set('title', newValue);

    this.forceUpdate();
  }

  handleSubmit = () => {
    const that = this;

    const semester = this.state.semester;
    semester.save().then(
      function(result) {
        that.props.onSave(result);
      },
      function(err) {
        console.log("Failed to save Semester " + err);
      });
  }

  formatDate(date) {
    return moment(date).format('ll');
  }

  render() {
    const semester = this.state.semester;

    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.props.onCancel} />,
      <FlatButton
        label="Save"
        primary={true}
        onClick={this.handleSubmit} />

    ];

    return (
      <Dialog
        open={this.props.open || true}
        title="Add Semester"
        actions={actions}
        onRequestClose={this.props.onCancel}
        autoScrollBodyContent={true}
        contentStyle={{maxWidth: '400px'}} >

        <form onSubmit={this.handleSubmit}>
          <div>
            <TextField
              id='add-semester-title'
              name='title'
              floatingLabelText="Title"
              onChange={this.handleTitleChange}
              value={semester.title}
              fullWidth={true} />

            <p className='input-definition'>
              Add a new Semester or school term such as "Senior Year" or "8th Grade".
            </p>

            <DatePicker
              floatingLabelText="Start Date"
              hintText="Start Date"
              value={semester.get('startDate')}
              onChange={this.handleStartDateChange}
              fullWidth={true}
              formatDate={this.formatDate} />

            <DatePicker
              floatingLabelText="End Date"
              hintText="End Date"
              value={semester.get('endDate')}
              onChange={this.handleStartDateChange}
              fullWidth={true}
              formatDate={this.formatDate} />   
          </div>
        </form> 

      </Dialog>          
    );
  }
}

export default SemesterAddDetail;


// WEBPACK FOOTER //
// ./src/scenes/Organizer/components/SemesterAddDetail.js